import { useDispatch, useSelector } from "react-redux";
import styles from "./ScrollableFavourites.module.scss";
import {
  clearFavouriteAndResetFilter,
  selectFavouriteAndUpdateFilter,
} from "../../../../actions/favourites";
import {
  DESELECT,
  FAVOURITES,
  FAVOURITES_ANALYTICS_VIEW,
  SELECT,
} from "../../../../constants/analytics";
import { sendAnalyticsEvent } from "../../../../lib/postMessage";

export const ScrollableFavourites = ({ favourites }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.filter);
  const { odds = {}, markets = [] } = filters;

  function isFavouriteSelected(favourite) {
    // check if markets are defined for each
    if (favourite.markets && markets) {
      // check if the number of markets is the same
      if (favourite.markets.length !== markets.length) return false;
      // check if the markets are the same
      if (
        favourite.markets.length > 0 &&
        !favourite.markets.every((market) => markets.includes(market))
      )
        return false;
    }

    // Check odds are defined for each
    if (favourite.odds && odds) {
      const { minOdds: favMin, maxOdds: favMax } = favourite.odds;
      const { minOdds: filterMin, maxOdds: filterMax } = odds;
      if (filterMin === null && filterMax === null) {
        return false;
      }
      // Check min odds are not equal to the favourite min odds (outside of the range)
      if (
        (filterMin !== null && filterMin !== favMin) ||
        (filterMin === null && favMin !== null)
      )
        return false;

      // Check max odds are not equal to the favourite max odds (outside of the range)
      if (
        (filterMax !== null &&
          filterMax !== Infinity &&
          filterMax !== favMax) ||
        (filterMax === Infinity && favMax !== Infinity)
      )
        return false;
    }

    return true;
  }

  function handleSelectFavourite(favourite) {
    if (isFavouriteSelected(favourite)) {
      dispatch(clearFavouriteAndResetFilter());
      sendAnalyticsEvent({
        event: FAVOURITES,
        type: FAVOURITES_ANALYTICS_VIEW,
        action: DESELECT,
        value: favourite.name,
      });
    } else {
      dispatch(selectFavouriteAndUpdateFilter(favourite));
      sendAnalyticsEvent({
        event: FAVOURITES,
        type: FAVOURITES_ANALYTICS_VIEW,
        action: SELECT,
        value: favourite.name,
      });
    }
  }

  return (
    <div className={styles.scrollableFavourites}>
      {favourites.map((favourite) => (
        <button
          type="button"
          key={favourite.id}
          className={`${styles.favourite} ${
            isFavouriteSelected(favourite) ? styles.favouriteActive : ""
          }`}
          onClick={() => handleSelectFavourite(favourite)}
        >
          {favourite.name}
        </button>
      ))}
    </div>
  );
};
